<template>
	<div 
		class="app-banner"
		:style="{ backgroundImage: `url(${data.image})` }">
		<div class="app-wrapper wrapper-app-banner">
			<div class="app-banner-logo text-center" v-if="product">
				<h1 class="app-banner-title">{{product.title || product}}</h1>
			</div>
			<div class="app-banner-logo text-center" v-else>
				<h1 class="app-banner-title">{{data.title}}</h1>
			</div>
			<div class="app-banner-logo-networks">
				<a href="#" class="margin-logo">
					<simple-svg
						:filepath="'/static/img/navbar-facebook-logo.svg'"
						:fill="colorLogo"
						:width="widthLogoFacebook" />
				</a>
				<a href="#" class="margin-logo">
					<simple-svg
						:filepath="'/static/img/navbar-google-plus.svg'"
						:fill="colorLogo"
						:width="widthLogoGoogle" />
				</a>
				<a href="#" class="margin-logo">
					<simple-svg
						:filepath="'static/img/navbar-youtube.svg'"
						:fill="colorLogo"
						:width="widthLogoYoutube" />
				</a>
			</div>
		</div>	
	</div>
</template>

<script>

	function data() {
		return {
			colorLogo: '#fff',
			widthLogoFacebook: '9',
			widthLogoGoogle: '17',
			widthLogoYoutube: '14',
		};
	}

	export default {
		name: 'app-banner',
		data,
		props: {
			data: {
				type: Object,
				required: true,
			},
			product: {
				type: [Object, String],
				default: () => {},
			},
		},
	};
</script>


<style lang="scss" scoped>
	.wrapper-app-banner {
		height: 100%;
	}

	.app-banner {
		background-position: center;
		background-size: cover;
		height: 100vh;
		position: relative;
	}

	.app-banner-logo {
		@include transform(translate(-50%, -50%));
		left: 50%;
		position: absolute;
		top: 45%;
	}

	.app-banner-logo-networks {
		@include flex-center;
		@include transform(translate(-50%, -50%));
		bottom: 60px;
		left: 50%;
		position: absolute;
	}

	.margin-logo {
		margin-right: 15px;
	}

	.app-banner-title {
		color: map-get($colors, white);
		font-family: map-get($fonts, maison-demi);
		font-size: 35px;
		line-height: 39px;
		text-align: center;
	}

	.text-center {
		text-align: center;
	}

	@media (min-width: 767px) {
		.view-mobile {
			display: none;
		}

		.app-banner {
			height: 368px;
		}
		
		.app-banner-logo-networks {
			display: none;
		}
  }

@media screen and (max-width: 600px) {
  .app-banner {
    max-height: 50vh;
  }

  .app-banner-logo {
    top: 80%;
  }

  .app-banner-logo-networks {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/app-banner.vue